// UploadTab Helpers
import { VALIDATION_STATUSES, FILE_STATUSES } from './constants';

/**
 * Check if validate button should be disabled
 */
export const isValidateDisabled = (validationStatus, status, validatingId, entryId) => {
  return validationStatus !== VALIDATION_STATUSES.PENDING || validatingId === entryId || status === FILE_STATUSES.PROCESSING;
};

/**
 * Check if process button should be disabled
 */
export const isProcessDisabled = (validationStatus, status, processingId, entryId) => {
  return (
    validationStatus !== VALIDATION_STATUSES.COMPLETED || 
    status === FILE_STATUSES.SAVED ||
    status === FILE_STATUSES.PROCESSING ||
    processingId === entryId
  );
};

/**
 * Check if eye button should be disabled
 */
export const isEyeDisabled = (validationFailedReason) => {
  return !validationFailedReason?.length;
};

/**
 * Get validate button tooltip
 */
export const getValidateTooltip = (validationStatus) => {
  return validationStatus !== VALIDATION_STATUSES.PENDING 
    ? 'First validate the file' 
    : 'Validate file';
};

/**
 * Get process button tooltip
 */
export const getProcessTooltip = (validationStatus, status) => {
  if (validationStatus !== VALIDATION_STATUSES.COMPLETED) {
    return 'First validate the file';
  }
  if (status === FILE_STATUSES.SAVED) {
    return 'File already processed';
  }
  return 'Process file';
};

/**
 * Get eye button tooltip
 */
export const getEyeTooltip = (validationFailedReason) => {
  return !validationFailedReason?.length 
    ? 'First validate the file' 
    : 'View validation errors';
};

/**
 * Format file size for display
 */
export const formatFileSize = (size) => {
  if (size > 1024 ** 3) {
    return (size / 1024 ** 3).toFixed(2) + ' GB';
  } else if (size > 1024 ** 2) {
    return (size / 1024 ** 2).toFixed(2) + ' MB';
  } else {
    return (size / 1024).toFixed(2) + ' KB';
  }
};

/**
 * Process excel entries data from API response
 */
export const processExcelEntries = (data) => {
  if (!data || !Array.isArray(data)) return [];
  
  return data.map((entry) => ({
    ...entry,
    validationFailedReason: Array.isArray(entry.validationFailedReason)
      ? entry.validationFailedReason
      : [],
  }));
};
